import React from 'react';

interface ImageTooltipProps {
  imageUrl: string;
  alt: string;
  show: boolean;
  position: { x: number; y: number };
}

const SIZE = 420;
const OFFSET = 10;
const VIEWPORT_MARGIN = 8;

const ImageTooltip: React.FC<ImageTooltipProps> = ({ imageUrl, alt, show, position }) => {
  if (!show || !imageUrl) return null;

  let left = position.x + OFFSET;
  let top = position.y - OFFSET;
  const pad = 4;
  const totalSize = SIZE + pad * 2;
  left = Math.max(VIEWPORT_MARGIN, Math.min(window.innerWidth - totalSize - VIEWPORT_MARGIN, left));
  top = Math.max(VIEWPORT_MARGIN, Math.min(window.innerHeight - totalSize - VIEWPORT_MARGIN, top));

  return (
    <div
      className="image-tooltip bg-dark border border-secondary rounded shadow-lg"
      style={{
        position: 'fixed',
        left,
        top,
        zIndex: 10000,
        pointerEvents: 'none',
        width: totalSize,
        height: totalSize,
        maxWidth: 'none',
        minWidth: 'auto',
        maxHeight: 'none',
        boxSizing: 'border-box',
        overflow: 'hidden',
        padding: pad,
        margin: 0
      }}
    >
      <img
        src={imageUrl}
        alt={alt}
        style={{
          width: SIZE,
          height: SIZE,
          objectFit: 'contain',
          display: 'block',
          margin: 0,
          padding: 0
        }}
      />
    </div>
  );
};

export default ImageTooltip;
